import type { FaireProductEntity } from "../../entity_types/product";

export const p_38quhvjgge: FaireProductEntity = {
  token: "p_38quhvjgge",
  type: "product",
  name: "Mini Turquoise Heart Earrings",
  brandToken: "b_962fea69",
  brandName: "Anna Beck Jewelry | Handmade in Bali",
  imageUrl:
    "https://cdn.faire.com/fastly/a6e8182bb8f0cb2c2f52ccc6283301fc7e6e61dd7e4a0f02b570afcd620566bf.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/7f0f87575748ff6c038530591cc40739da93e673013df9a6e5f0412a87facc0a.jpeg",
    "https://cdn.faire.com/fastly/0ae03bdbd0163f1f8a77fc76823140d58eff2fcd48b8bdf14ec4d7bf06fac6b0.jpeg",
  ],
  priceDollars: 122,
  description:
    "Petite turquoise heart drops add a soft, playful touch to these lightweight everyday earrings. Simple, symbolic, and easy to wear, they’re the perfect hint of color and meaning for any look.\n\nPRODUCT DETAILS:\n\n * Handmade in Bali \n * 18k gold plating over sterling silver \n * Earring size: 10.20mm x 18.25mm \n * Turquoise is the stone of protection, wisdom, and clear communication ",
  tags: [],
  msrpDollars: 286.7,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:53:16.995Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
